export const COMPANY_NAME = 'BOOK BUS';
export const COMPANY_ADDRESS_STREET = '3614 Section Rd';
export const COMPANY_ADDRESS_CITY = 'Cincinnati';
export const COMPANY_ADDRESS_STATE = 'OH';
export const COMPANY_ADDRESS_ZIP = '45237-2510';
export const COMPANY_ADDRESS_FULL = '3614 Section Rd, Cincinnati, OH 45237-2510';
export const COMPANY_LOCATION = 'Cincinnati, Ohio';

export const MAP_URL = 'https://www.google.com/maps/search/?api=1&query=3614%20Section%20Rd%2C%20Cincinnati%2C%20OH%2045237-2510';

export const COMPANY_FACTS = [
  {
    label: 'Business Type',
    value: 'Mobile Bookstore',
  },
  {
    label: 'Focus',
    value: 'New & Used Books',
  },
  {
    label: 'Community Role',
    value: 'Educational Book Access',
  },
];

export const SERVICES = [
  {
    title: 'Mobile Bookstore',
    description: 'Public listings describe Cincy Book Bus as a mobile bookstore based in Cincinnati, Ohio.',
  },
  {
    title: 'Curated Book Selection',
    description: 'The book bus is described as offering a curated selection of new and used books.',
  },
  {
    title: 'Community & Education',
    description: 'Public nonprofit directories list BOOK BUS under charitable and educational organization categories.',
  },
];
